<!-- =========================================================================================
  File Name: CompanyViewSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<template>
	<vs-sidebar
		click-not-close
		position-right
		parent="body"
		default-index="1"
		color="primary"
		class="add-new-data-sidebar items-no-padding"
		spacer
		v-model="isSidebarActiveLocal"
	>
		<div class="mt-6 flex items-center justify-between px-6">
			<h4>{{ $t("MapModule.MapOptions") }}</h4>
			<feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
		</div>
		<vs-divider class="mb-0"></vs-divider>
		<vs-popup :fullscreen="fullscreen" class="holamundo" title="Schedule list" :active.sync="popupActiveShow">
			<vs-button
				@click="fullscreen = !fullscreen"
				class="btn-maximize"
				color="primary"
				type="line"
				icon-pack="feather"
				:icon="fullscreen ? 'icon-minimize-2' : 'icon-maximize-2'"
			></vs-button>
			<export-selected
				@closePopupEmit="closePopup"
				@unmountExportEmit="unmountExport"
				v-if="popupActive"
			></export-selected>
		</vs-popup>
		<div class="tab-size" :style="{overflowY: 'auto', height: windowHeight < 600 ? 90 + 'vh' : 95 + 'vh'}">
			<vs-tabs v-model="tabActive">
				<!-- TRACKING TAB -->
				<vs-tab :label="$t('MapModule.RealTimeTracking')">
					<!-- START TOOLS BAR -->
					<vs-navbar :type="'border'" v-model="activeItem" class="nabarx mb-5">
						<div slot="title">
							<vs-navbar-title>
								<span> {{ $t("MapModule.Views") }} </span>
							</vs-navbar-title>
						</div>

						<vs-navbar-item :index="0">
							<a @click="changeView('LIST')">
								<div class="flex flex-col items-center justify-center">
									<vx-tooltip
										class="cursor-pointer"
										style="z-index: 99999"
										:title="$t('MapModule.ListView')"
										color="primary"
										position="bottom"
										:text="$t('MapModule.ChangeListView')"
									>
										<vs-icon
											icon="view_list"
											size="medium"
											:color="activeItem === 0 ? 'primary' : 'secondary'"
										></vs-icon>
									</vx-tooltip>
									<small>{{ $t("MapModule.ListView") }}</small>
								</div>
							</a>
						</vs-navbar-item>
						<vs-navbar-item :index="1">
							<a @click="changeView('CARDS')">
								<div class="flex flex-col items-center justify-center">
									<vx-tooltip
										style="z-index: 99999"
										:title="$t('MapModule.CardView')"
										color="primary"
										position="bottom"
										:text="$t('MapModule.ChangeCardView')"
									>
										<vs-icon
											icon="account_box"
											class="cursor-pointer"
											size="medium"
											:color="activeItem === 1 ? 'primary' : 'secondary'"
										></vs-icon>
									</vx-tooltip>
									<small>{{ $t("MapModule.CardsView") }}</small>
								</div>
							</a>
						</vs-navbar-item>
						<vs-navbar-item :index="2" v-if="selectedGroup.resource_id.length > 0">
							<export-transmission></export-transmission>
						</vs-navbar-item>
					</vs-navbar>
					<!-- GROUP SELECTOR -->
					<group-list-selector class="mb-base" @changeGroupEmit="changeGroupEmit">
						<div class="search-page__search-bar flex items-center mt-4">
							<vs-input
								icon-no-border
								:placeholder="$t('Search')"
								v-model="searchQuery"
								class="w-full"
								icon="icon-search"
								icon-pack="feather"
							/>
						</div>
					</group-list-selector>
					<vue-perfect-scrollbar
						class="scroll-area"
						:style="{height: windowHeight < 600 ? '300px' : 55 + 'vh'}"
						:settings="settings"
					>
						<div id="content-resource-select" class="vs-con-loading__container">
							<!-- VISTA EN CARDS -->
							<div v-if="viewType === 'CARDS' && resourcesDataFilter.length > 0 && !loadedingResource">
								<card-transmision
									v-for="resource in resourcesDataFilter"
									:key="resource.uid"
									:resource="resource"
									@openExportPopupEmit="openExportPopup"
								/>
							</div>
							<!-- VISTA EN LISTA -->
							<div v-if="viewType === 'LIST' && resourcesDataFilter.length > 0 && !loadedingResource">
								<ul class="bordered-items">
									<li
										class="cursor-pointer"
										v-for="resource in resourcesDataFilter"
										:key="resource.uid"
									>
										<list-item-transmision
											:resource="resource"
											@openExportPopupEmit="openExportPopup"
										/>
									</li>
								</ul>
							</div>

							<div
								class="flex w-full bg-img mt-2"
								v-if="!loadedingResource && resourcesDataFilter.length === 0"
							>
								<div class="vx-col flex items-center justify-center flex-col mx-auto text-center">
									<img
										src="@/assets/images/pages/graphic-6.png"
										alt="graphic-graphic-6"
										class="mx-auto mb-4"
									/>
									<h1 class="sm:mx-0 mx-4 sm:mb-5 mb-5 text-4xl d-theme-heading-color">
										{{ $t("ResourceList") }}
									</h1>
									<p class="sm:mx-0 mx-4 sm:mb-12 mb-5 text-primary">
										{{
											resourcesDataFilter.length === 0 && loadedingResult === null
												? $t("MapModule.AlertVisualizarInfo")
												: $t("MapModule.ResourcesNotFound")
										}}
									</p>
								</div>
							</div>
							<div class="flex w-full bg-img mt-6" v-if="loadedingResource">
								<div class="vx-col flex items-center justify-center flex-col mx-auto text-center mt-6">
									<loading />
								</div>
							</div>
						</div>
					</vue-perfect-scrollbar>
				</vs-tab>
				<!-- ROUTES TAB -->
				<vs-tab :label="$t('MapModule.Routes')">
					<div class="tab-text">
						<vs-navbar :type="'border'" v-model="activeItemRoutes" class="nabarx mb-5">
							<div slot="title">
								<vs-navbar-title>
									<span>{{ type }}</span>
								</vs-navbar-title>
							</div>
							<vs-navbar-item :index="0">
								<a @click="changeOptions(2)">
									<div class="flex flex-col items-center justify-center">
										<vx-tooltip
											style="z-index: 99999"
											color="primary"
											position="bottom"
											:title="$t('Config')"
											:text="$t('MapModule.ConfigText')"
										>
											<vs-icon
												icon="settings"
												size="medium"
												:color="selectedOption === 'Schedule' ? 'primary' : 'secondary'"
												class="cursor-pointer"
											></vs-icon>
										</vx-tooltip>
										<small>{{ $t("Config") }}</small>
									</div>
								</a>
							</vs-navbar-item>
							<vs-navbar-item :index="1">
								<a @click="changeOptions(3)">
									<div class="flex flex-col items-center justify-center">
										<vx-tooltip
											style="z-index: 99999"
											:title="$t('MapModule.SearchRoutes')"
											color="primary"
											position="left"
											text="Visualizar las rutas programadas y ejecutas de los recursos."
										>
											<vs-icon
												icon="assistant_direction"
												size="medium"
												:color="selectedOption === 'Routes' ? 'primary' : 'secondary'"
												class="cursor-pointer"
											></vs-icon>
										</vx-tooltip>
										<small>{{ $t("MapModule.SearchRoutes") }}</small>
									</div>
								</a>
							</vs-navbar-item>
						</vs-navbar>
						<vx-card
							v-if="activeItemRoutes === 1"
							no-shadow
							:title="$t('MapModule.SearchRoutes')"
							class="vs-con-loading__container max-heigth"
							id="content-resource-select"
						>
							<div class="vx-row">
								<div class="vx-col w-full">
									<label class="vs-input--label">{{ $t("MapModule.RouteType") }}</label>
									<v-select
										class="select-large"
										v-model="routeType"
										:clearable="false"
										:options="routeTypeOptions"
										name="resource"
										:dir="$vs.rtl ? 'rtl' : 'ltr'"
									>
										<template v-slot:no-options="{search, searching}">
											<template v-if="searching">
												{{ $t("general.NoResultsFoundFor") + " " }}<em>{{ search }}</em>
											</template>
										</template>
									</v-select>
								</div>
								<div class="vx-col w-full my-1">
									<!-- GROUP SELECTOR -->
									<group-select @changeGroupEmit="changeGroupEmit" />
								</div>
								<div class="vx-col w-full my-1">
									<label class="vs-input--label">{{ $t("general.SearchResourceBy") }}</label>
									<v-select
										v-model="searchFieldSelected"
										v-validate="'required'"
										name="selectedResource"
										:clearable="false"
										:options="searchOptions"
										:dir="$vs.rtl ? 'rtl' : 'ltr'"
										:disabled="resourcesForSelect.length === 0"
									>
										<template v-slot:no-options="{search, searching}">
											<template v-if="searching">
												{{ $t("general.NoResultsFoundFor") + " " }}<em>{{ search }}</em>
											</template>
										</template>
									</v-select>
								</div>
								<div class="vx-col w-full my-1">
									<label class="vs-input--label">{{ $t("Resource.Resources") }}</label>
									<v-select
										:multiple="routeType.value === 'EXECUTED' || routeType.value === 'PROGRAMED'"
										class="select-large"
										v-model="select1"
										:clearable="false"
										:options="resourcesForSelect"
										name="resource"
										:dir="$vs.rtl ? 'rtl' : 'ltr'"
										:disabled="resourcesForSelect.length === 0"
									>
										<template v-slot:no-options="{search, searching}">
											<template v-if="searching">
												{{ $t("general.NoResultsFoundFor") + " " }}<em>{{ search }}</em>
											</template>
										</template>
										<template #option="{username, label}">
											<span>{{ username }}</span>
											<br />
											<cite v-if="searchField !== 'username'" style="font-size: 12px">{{
												label
											}}</cite>
										</template>
										<li slot="list-footer" class="pagination">
											<vs-pagination
												:total="totalPages"
												:max="7"
												v-model="currentPage"
												class="mt-5"
											/>
										</li>
									</v-select>
								</div>
								<div class="vx-col w-full my-1">
									<div>
										<small class="date-label">{{ $t("InitDate") }}</small>
										<datepicker
											:language="$vs.rtl ? langHe : langEn"
											name="start-date"
											v-model="startDate"
											:disabledDates="disabledDatesFrom"
										></datepicker>
									</div>
								</div>
							</div>
							<vs-button
								class="mr-4 mt-4 vs-con-loading__container"
								id="btn-excute-route"
								:disabled="!select1"
								@click="handleSubmit"
								>{{ btnTextSubmit }}
							</vs-button>
						</vx-card>
						<routes-config
							v-else
							:qtyResource="select1 ? select1.length : 0"
							@showMarkersForExecutedRouteEmit="showMarkersForExecutedRoute"
							@enableMarkerLabelsForExecutedRouteEmit="enableMarkerLabelsForExecutedRoute"
							@togglePolylineEmit="drawTogglePolyline"
							@changePropertiesAuxiliaryRouteEmit="changePropertiesAuxiliaryRouteEmit"
						></routes-config>
					</div>
				</vs-tab>
				<!-- VISIT POINTS TAB -->
				<vs-tab :label="$t('general.VisitPoints')">
					<div class="tab-text">
						<div class="vx-col w-full">
							<visit-point-list
								:customConfig="visitPointListConfig"
								:style="{height: windowHeight < 600 ? '880px' : 100 + '%'}"
							>
								<div>
									<h4 v-text="$t('general.VisitPoints')"></h4>
									<p class="mt-2" v-text="$t('general.VisitingPointsDescription')"></p>
									<vs-button class="mt-4 mb-4" id="btn-locate-visit-point" @click="drawVisitPoints"
										>{{ $t("Locate") }}
									</vs-button>
								</div>
							</visit-point-list>
						</div>
					</div>
				</vs-tab>
				<!-- RESCOURCE SCHEDULE -->
				<vs-tab :label="$t('Schedule.Schedules')">
					<div class="tab-text">
						<div class="max-heigth">
							<vx-card
								:title="$t('Schedule.SearchSchedule')"
								class="vs-con-loading__container"
								id="content-resource-select"
							>
								<div class="vx-row">
									<div class="vx-col w-full my-1">
										<!-- GROUP SELECTOR -->
										<group-select @changeGroupEmit="changeGroupEmit" />
									</div>
									<div class="vx-col w-full my-1">
										<label class="vs-input--label">{{ $t("general.SearchResourceBy") }}</label>
										<v-select
											v-model="searchFieldSelected"
											v-validate="'required'"
											name="selectedResource"
											:clearable="false"
											:options="searchOptions"
											:dir="$vs.rtl ? 'rtl' : 'ltr'"
											:disabled="resourcesForSelect.length === 0"
										>
											<template v-slot:no-options="{search, searching}">
												<template v-if="searching">
													{{ $t("general.NoResultsFoundFor") + " " }}<em>{{ search }}</em>
												</template>
											</template>
										</v-select>
									</div>
									<!-- Must have a value that is in the specified list : 1 or 3 -->
									<div class="vx-col w-full my-1">
										<label class="vs-input--label">{{ $t("Resource.Resources") }}</label>
										<v-select
											class="select-large"
											v-model="select1"
											:clearable="false"
											:options="resourcesForSelect"
											name="resource"
											:dir="$vs.rtl ? 'rtl' : 'ltr'"
											:disabled="resourcesForSelect.length === 0"
										>
											<template v-slot:no-options="{search, searching}">
												<template v-if="searching">
													{{ $t("general.NoResultsFoundFor") + " " }}<em>{{ search }}</em>
												</template>
											</template>
											<template #option="{username, label}">
												<span>{{ username }}</span>
												<br />
												<cite v-if="searchField !== 'username'" style="font-size: 12px">{{
													label
												}}</cite>
											</template>
											<li slot="list-footer" class="pagination">
												<vs-pagination
													:total="totalPages"
													:max="7"
													v-model="currentPage"
													class="mt-5"
												/>
											</li>
										</v-select>
									</div>
									<!-- date -->
									<div class="vx-col w-full my-1">
										<div>
											<small class="date-label">{{ $t("InitDate") }}</small>
											<datepicker
												:language="$vs.rtl ? langHe : langEn"
												name="start-date"
												v-model="startDate"
												:disabledDates="disabledDatesFrom"
											></datepicker>
										</div>
									</div>
									<!-- date -->
									<div class="vx-col w-full my-1">
										<div>
											<small class="date-label">{{ $t("EndDate") }}</small>
											<datepicker
												:language="$vs.rtl ? langHe : langEn"
												:disabledDates="disabledEndDatesTo"
												name="end-date"
												v-model="endDate"
											></datepicker>
											<span class="text-danger text-sm" v-show="!validateEndDate">{{
												$t("Reports.EndDateGreaterOrEqualInitDate")
											}}</span>
										</div>
									</div>
								</div>
								<vs-button
									class="mr-4 mt-4 vs-con-loading__container"
									id="btn-excute-route"
									:disabled="!select1 || !validateEndDate"
									@click="getResourceEvents"
									>{{ btnTextSubmit }}
								</vs-button>
							</vx-card>
						</div>
					</div>
				</vs-tab>
			</vs-tabs>
		</div>
		<div ref="container_infowindow"></div>
		<vs-prompt
			@cancel="clearValMultiple"
			@accept="acceptAlert"
			@close="close"
			:active.sync="activeConfirmKeepGroupPrompt"
			:acceptText="this.$t('Accept')"
			:cancelText="this.$t('Cancel')"
			:title="$t('Groups.DefaultGroup')"
		>
			<div>
				<b>{{ selectedGroup.name }}</b
				>, {{ $t("Groups.FavoriteConfirmText") }}
				<ul class="demo-alignment">
					<li>
						<vs-checkbox v-model="checkBoxDefaultGroup"> {{ $t("Groups.AskForAgain") }}</vs-checkbox>
					</li>
				</ul>
			</div>
		</vs-prompt>
	</vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker";
import {en, es} from "vuejs-datepicker/src/locale";
import DateUtils from "@/helpers/DateUtils.js";
import GroupListSelector from "@/components/group/GroupListSelector.vue";
import GroupSelect from "@/components/group/GroupSelect.vue";
import visitPointImg from "@/assets/images/markers/visit_point.png";
import {generateInfowindowContentSchedule, generateInfowindowContentVisitPoints} from "./infowindowContent.js";
import Commons from "@/helpers/commons.js";
import MapMethods from "./mapMethods";
import Loading from "./Loading.vue";
import moduleResource from "@/store/resource/moduleResource.js";
import moduleVisitPoint from "@/store/visit-point/moduleVisitPoint.js";
import moduleSchedule from "@/store/schedule/moduleSchedule.js";
import {BatteryChargingIcon, BatteryIcon} from "vue-feather-icons";
import CardTransmision from "./CardTransmision";
import ListTransmision from "./ListTransmision";
import ListItemTransmision from "./ListItemTransmision";
import ExportSelected from "./ExportSelected.vue";
import VisitPointList from "../visit-point/list/VisitPointList.vue";
import RoutesConfig from "./RoutesConfig.vue";
import {
	addDomMarker,
	addInfoBubble,
	addMarkerHereMap,
	changeAuxiliaryRouteOptions,
	clearMap,
	enableMarkerLabel,
	fitBoundsMarkerGroup,
	removeRoute,
	togglePolyline,
} from "../../utils/HereMap";
import Button from "../../views/components/vuesax/button/Button";
import ExportTransmission from "./ExportTransmission.vue";
import VisitPoint from "@/models/VisitPoint.js";
import Group from "@/models/Group.js";
import moduleGroup from "@/store/group/moduleGroup.js";

export default {
	props: {
		isSidebarActive: {
			type: Boolean,
			required: true,
		},
		handleChangeGroupTrigger: {
			type: Function,
		},
	},
	components: {
		Button,
		VuePerfectScrollbar,
		vSelect,
		CardTransmision,
		ListTransmision,
		BatteryChargingIcon,
		BatteryIcon,
		ExportSelected,
		Datepicker,
		VisitPointList,
		ListItemTransmision,
		RoutesConfig,
		GroupListSelector,
		Loading,
		GroupSelect,
		ExportTransmission,
	},
	data() {
		return {
			optimizeWaypoints: false,
			instanceInfo: null,
			resourcesDataLocal: [],
			resourcesDataLocalSelect: [],
			searchQuery: null,
			viewType: "CARDS",
			tabActive: 0,
			popupActive: false,
			popupActiveShow: false,
			popupStreeViewActive: false,
			activeItem: 1,
			type: "Options",
			date_between_init: "",
			date_between_end: "",
			select1: null,
			settings: {
				// perfectscrollbar settings
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
			selectedOption: "Routes",
			batteryStatus: {
				alert: {
					icon: "battery_alert",
					color: "FEDEDE",
				},
				full: {
					icon: "battery_full",
					color: "FEDEDE",
				},
			},
			fullscreen: false,
			startDate: new Date(),
			endDate: "",
			langHe: es,
			langEn: en,
			markerArray: [],
			possitionArray: [],
			routeType: {label: this.$t("Programed"), value: "PROGRAMED"},
			searchFieldSelected: {value: "username", label: this.$t("Username")},
			searchField: "username",
			colorLoading: "#fff",
			//Config Visit Point List
			visitPointListConfig: {
				rowSelection: "multiple", // multiple | single
				activeCheckbox: true,
				activeHeaderCheckboxSelection: true,
				activeLink: false,
				columns: ["identification", "name", "address", "city", "phone", "typology_name"],
				tableOptions: false,
				showItemsPerPage: false,
				showSearch: false,
				showActions: false,
			},
			pagination: {
				next_page: 0,
				total_pages: 0,
				total_records: 0,
			},
			currentPageLocal: 1,
			quantityElementPage: 100,
			activeItemRoutes: 1,
			loadedingResource: false,
			loadedingResult: null,
			windowHeight: screen.height,
			windowWidth: screen.width,
			executedRouteData: null,
			executedRoutePolyline: null,
			activeConfirmKeepGroupPrompt: false,
			val: "",
			valMultipe: {
				value1: "",
				value2: "",
			},
			checkBoxDefaultGroup: false,
			selectedGroup: new Group({}),
		};
	},
	created() {
		if (!moduleResource.isRegistered) {
			this.$store.registerModule("moduleResource", moduleResource);
			moduleResource.isRegistered = true;
		}

		if (!moduleVisitPoint.isRegistered) {
			this.$store.registerModule("moduleVisitPoint", moduleVisitPoint);
			moduleVisitPoint.isRegistered = true;
		}

		if (!moduleSchedule.isRegistered) {
			this.$store.registerModule("moduleSchedule", moduleSchedule);
			moduleSchedule.isRegistered = true;
		}
		if (!moduleGroup.isRegistered) {
			this.$store.registerModule("moduleGroup", moduleGroup);
			moduleGroup.isRegistered = true;
		}
	},
	mounted() {
		window.addEventListener("resize", () => {
			this.windowHeight = window.innerHeight;
			this.windowWidth = window.innerWidth;
		});
	},
	watch: {
		searchFieldSelected(val) {
			this.searchField = val.value;
		},
		routeType(val) {
			this.select1 = null;
			this.$store.commit("moduleMap/SET_ROUTE_TYPE", val.value);
		},
		itemsPerPage(val) {
			this.quantityElementPage = val;
			this.currentPage = 1;
		},
		currentPage() {
			this.getResources({
				page: this.currentPage,
				quantity: this.quantityElementPage,
			});
		},
		tabActive() {
			clearMap();
			removeRoute();
			this.pagination = {
				next_page: 0,
				total_pages: 0,
				total_records: 0,
			};
			this.currentPageLocal = 1;
			this.select1 = null;
		},
		select1(val) {
			if (val) {
				for (const [key, value] of Object.entries(val)) {
					if (key === "value" && !this.colorMap.has(value)) {
						const data = {
							resourceId: value,
							color: this.genterateRandonColor(),
						};
						this.$store.commit("moduleMap/SET_MAP_COLOR", data);
					}
				}
			}
		},
		checkBoxDefaultGroup(val) {
			this.$store.commit("ASK_AGAIN_FAVORITE_GROUP", val);
		},
	},
	computed: {
		searchOptions() {
			return [
				{value: "name", label: this.$t("Name")},
				{value: "lastname", label: this.$t("Lastname")},
				{value: "identification", label: this.$t("Identification")},
				{value: "username", label: this.$t("Username")},
				{value: "email", label: this.$t("Email")},
			];
		},
		height() {
			let newHeight = 500;
			if (this.windowHeight > 800) {
				newHeight = screen.height * 0.46;
			}
			return newHeight;
		},
		validateEndDate() {
			if (typeof this.endDate === "object") {
				if (this.endDate.getTime() >= this.startDate.getTime()) return true;
			} else {
				return true;
			}
		},
		currentPage: {
			get() {
				return this.currentPageLocal;
			},
			set(val) {
				this.currentPageLocal = val;
			},
		},
		paginationPageSize() {
			if (this.pagination.total_records > 0) {
				return this.pagination.total_records;
			}
		},
		totalPages() {
			if (this.pagination.total_pages > 0) return this.pagination.total_pages;
			else return 0;
		},
		btnTextSubmit() {
			return this.$t("Submit");
		},
		routeTypeOptions() {
			return [
				{label: this.$t("Programed"), value: "PROGRAMED"},
				{label: this.$t("Executed"), value: "EXECUTED"},
				{label: this.$t("Both"), value: "BOTH"},
			];
		},
		resourcesDataFilter() {
			const data = this.resourcesDataLocal;
			if (!this.searchQuery || this.searchQuery.trim().length <= 0) {
				return data;
			}
			return data.filter((r) => {
				return (
					r.name.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
					r.username.toLowerCase().includes(this.searchQuery.toLowerCase())
				);
			});
		},
		resourcesForSelect() {
			return this.resourcesDataLocalSelect.map((resource) => {
				return {
					username: resource["username"],
					label: resource[this.searchField],
					value: resource.id,
				};
			});
		},
		resourcesData() {
			return this.resourcesDataLocal;
		},
		isSidebarActiveLocal: {
			get() {
				return this.isSidebarActive;
			},
			set(val) {
				if (!val) {
					this.$emit("closeSidebar");
				}
			},
		},
		scrollbarTag() {
			return this.$store.getters.scrollbarTag;
		},
		today() {
			const f = new Date("Tue, 18 Mar 2025 19:35:52 GMT");
			return DateUtils.toDefaultDateTime(f, "YYYY-MM-DD");
		},
		disabledEndDatesTo() {
			return {to: new Date(this.startDate)};
		},
		disabledDatesTo() {
			if (this.routeType.value !== "PROGRAMED") {
				return {to: new Date()};
			}
		},
		disabledDatesFrom() {
			if (this.routeType.value !== "PROGRAMED") {
				return {from: new Date()};
			}
		},
		colorMap() {
			return this.$store.state.moduleMap.colorMap;
		},
	},
	methods: {
		mountInfowindowComponent(visitPoint) {
			if (this.instanceInfo) {
				this.instanceInfo.$destroy();
				this.$refs.container_infowindow.textContent = "";
			}
			this.instanceInfo = new ComponentClass({
				propsData: {
					visit_point: new VisitPoint(visitPoint),
					hearMe: () => {},
				},
			});
			this.instanceInfo.$mount();
			this.$refs.container_infowindow.appendChild(this.instanceInfo.$el);
		},
		showMarkersForExecutedRoute() {
			if (!this.executedRouteData) return;
			const options = {
				strokeColor: "#000000", //color del borde
				strokeWeight: 1, //grosor del borde
				fillColor: this.$store.state.moduleMap.optionsExecutedRoute.lineWaypointsStrokeColor,
				label: this.$store.state.moduleMap.optionsExecutedRoute.waypointsLabel,
			};
			MapMethods.drawExecuteRouteWaypoints.call(this, this.executedRouteData, options);
		},
		enableMarkerLabelsForExecutedRoute(val) {
			if (this.executedRoutePolyline) {
				enableMarkerLabel(val);
			}
		},
		drawTogglePolyline(val) {
			if (!this.executedRoutePolyline && this.executedRouteData) {
				MapMethods.drawAuxiliaryExecuteRoute.call(
					this,
					this.executedRouteData,
					this.$store.state.moduleMap.optionsExecutedRoute
				);
				return;
			}

			if (this.executedRoutePolyline) {
				togglePolyline(this.executedRoutePolyline, val);
			}
		},
		changePropertiesAuxiliaryRouteEmit(val) {
			if (this.executedRoutePolyline) {
				changeAuxiliaryRouteOptions(this.executedRoutePolyline, val);
			}
		},
		changeView(opc) {
			this.viewType = opc;
		},
		handleSubmit() {
			switch (this.selectedOption) {
				case "Routes":
					this.getRoute();
					break;
				case "Schedule":
					this.getResourceEvents();
					break;
				case "Visit Points":
					break;
				default:
					this.getRoute();
					break;
			}
		},
		changeOptions(opc) {
			switch (opc) {
				case 1:
					this.selectedOption = "Visit Points";
					break;
				case 2:
					this.selectedOption = "Schedule";
					break;
				case 3:
					this.selectedOption = "Routes";
					break;
				default:
					break;
			}
		},
		toggleDataSidebar() {
			this.$emit("closeSidebar");
		},
		closePopup() {
			this.popupActiveShow = false;
		},
		unmountExport() {
			this.popupActive = false;
		},
		openExportPopup() {
			this.popupActive = true;
			this.popupActiveShow = true;
		},
		//Init Tab Route
		getRoute() {
			switch (this.routeType.value) {
				case "PROGRAMED":
					this.getProgrammedRoute();
					break;
				case "EXECUTED":
					this.getExecutedRoute();
					break;
				case "BOTH":
					this.getProgrameAndExecute();
					break;
				default:
					this.$vs.notify({
						color: "warning",
						title: this.$t("Schedule.ValidData.Title"),
						text: this.$t("Schedule.ValidData.Text"),
					});
					break;
			}
		},
		getProgrameAndExecute() {
			clearMap();
			removeRoute();
			Commons.openLoadingButton.call(this, `btn-excute-route`);
			const date = DateUtils.toDefaultDateTime(this.startDate, "YYYY-MM-DD");
			const payloadExcuted = {
				init_date: date,
				end_date: date,
				resources_id: [this.select1.value],
				distance: 0.1,
			};
			const payloadProgramed = {
				init_date: date,
				end_date: date,
				resource_id: this.select1.value,
			};
			const p1 = this.$store.dispatch("moduleSchedule/fetchEventsByResourceId", payloadProgramed);
			const p2 = this.$store.dispatch("moduleMap/getExecutedRoute", payloadExcuted);

			Promise.all([p1, p2]).then(
				(values) => {
					MapMethods.drawProgramedRoute.call(
						this,
						values[0].data.records,
						this.$store.state.moduleMap.optionsProgramedRoute,
						true
					);
					MapMethods.drawExecuteRoute.call(
						this,
						values[1].data,
						this.$store.state.moduleMap.optionsExecutedRoute
					);
					Commons.closeLoadingButton.call(this, `btn-excute-route`);
				},
				(reason) => {
					Commons.closeLoadingButton.call(this, `btn-excute-route`);
				}
			);
			Commons.closeLoadingButton.call(this, `btn-excute-route`);
		},
		getProgrammedRoute(clear = true) {
			if (clear) {
				clearMap();
				removeRoute();
			}
			const date = DateUtils.toDefaultDateTime(this.startDate, "YYYY-MM-DD");
			const selectedResources =
				this.select1.length > 1 ? this.select1.map(({value}) => value) : this.select1[0].value;
			const isArraySelectedResources = Array.isArray(selectedResources);
			const payload = {
				init_date: date,
				end_date: date,
				resource_id: selectedResources,
			};
			// Agregar opcion de agrupar data por recursos si el numero de recursos es mayor a 1
			Object.assign(payload, isArraySelectedResources ? {group_by: true} : {});
			this.setRandonColor();
			Commons.openLoadingButton.call(this, `btn-excute-route`);
			this.$store
				.dispatch("moduleSchedule/fetchEventsToProgramedRoute", payload)
				.then((res) => {
					Commons.closeLoadingButton.call(this, `btn-excute-route`);
					let arrayLegends = [];
					if (isArraySelectedResources) {
						// // bug: isue expect a json but obtain an array, is nescerary to parse it to require format
						const events = res.data.records;
						const data = {};
						// create an Object to fill it with the object keys obtains from res.data.records
						selectedResources.forEach((e) => {
							data[e] = events.filter((event) => event.resource_id === e);
						});
						for (const route in data) {
							const randomColor = this.colorMap.get(parseInt(route));
							if (Object.hasOwnProperty.call(data, route)) {
								let resourceData = this.select1.find((e) => e.value === parseInt(route));
								const element = data[route];
								arrayLegends.push({
									id: route,
									resource: resourceData,
									color: randomColor,
									route: {total_visit: element.length},
								});
								MapMethods.drawProgramedRoute.call(this, element, {
									...this.$store.state.moduleMap.optionsProgramedRoute,
									strokeColor: randomColor,
								});
							}
						}
					} else {
						MapMethods.drawProgramedRoute.call(
							this,
							res.data.records,
							this.$store.state.moduleMap.optionsProgramedRoute,
							true
						);
						let resourceData = this.select1[0];
						arrayLegends.push({
							id: resourceData.value,
							resource: resourceData,
							color: this.$store.state.moduleMap.optionsProgramedRoute.strokeColor,
							route: {total_visit: res.data.records.length | 0},
						});
					}
					this.$store.commit("moduleMap/RESOURCES_ROUTES_LEGENDS", arrayLegends);
					this.$store.commit("moduleMap/TOGGLE_ROUTES_LEGENDS", true);
				})
				.catch((err) => {
					Commons.closeLoadingButton.call(this, `btn-excute-route`);
					this.$vs.notify({
						color: "danger",
						title: this.$t("ErrorTitle"),
						text: this.$t("MapModule.ErrorGenerateAppointment.Text"),
					});
					throw new Error(err);
				});
		},
		async getExecutedRoute(clear = true) {
			if (clear) {
				clearMap();
				removeRoute();
			}
			const date = DateUtils.toDefaultDateTime(this.startDate, "YYYY-MM-DD");
			const payload = {
				init_date: date,
				end_date: date,
				resources_id:
					this.routeType.value === "EXECUTED" ? this.select1.map(({value}) => value) : [this.select1.value],
				distance: 0.1,
			};
			// Agregar opcion de agrupar data por recursos si el numero de recursos es mayor a 1
			Object.assign(payload, payload.resources_id.length > 1 ? {group_by: true} : {});
			Commons.openLoadingButton.call(this, `btn-excute-route`);
			this.setRandonColor();
			try {
				const result = await this.$store.dispatch("moduleMap/getExecutedRoute", payload);
				Commons.closeLoadingButton.call(this, `btn-excute-route`);
				let arrayLegends = [];
				if (payload.resources_id.length > 1) {
					for (const key in result.data) {
						if (Object.hasOwnProperty.call(result.data, key)) {
							const element = result.data[key];
							let resourceData = this.select1.find((e) => e.value === parseInt(key));
							const randomColor = this.colorMap.get(parseInt(key));
							const optionsExecutedRoute = {
								strokeColor: randomColor,
								strokeOpacity: 0.8,
								lineWidth: 8,
								optimizeWaypoints: false,
								id: key,
							};
							arrayLegends.push({
								id: key,
								resource: resourceData,
								color: randomColor,
								route: element[element.length - 1],
							});
							MapMethods.drawExecuteRoute.call(this, element, optionsExecutedRoute);
						}
					}
				} else {
					let resourceData = this.select1[0];
					arrayLegends.push({
						id: resourceData.value,
						resource: resourceData,
						color: this.$store.state.moduleMap.optionsExecutedRoute.strokeColor,
						route: result.data[result.data.length - 1],
					});
					MapMethods.drawExecuteRoute.call(
						this,
						result.data,
						this.$store.state.moduleMap.optionsExecutedRoute
					);
					this.executedRouteData = result.data;
				}
				this.$store.commit("moduleMap/RESOURCES_ROUTES_LEGENDS", arrayLegends);
				const date = DateUtils.toDefaultDateTime(this.startDate, "YYYY-MM-DD");
				this.getEvents(date, date, true);
				this.$store.commit("moduleMap/TOGGLE_ROUTES_LEGENDS", true);
			} catch (error) {
				Commons.closeLoadingButton.call(this, `btn-excute-route`);
				throw new Error(error);
			}
		},
		addMarkerRoute(lat, lng, infoWindowData) {
			let options = {
				drag: false,
				icon:
					this.routeType.value === "PROGRAMED" || this.routeType.value === "BOTH"
						? MapMethods.generateMarkerIconEvent(infoWindowData.event_status_id)
						: null,
				title: "Current position",
				label: {
					text: " " + (infoWindowData.index ? infoWindowData.index : " "),
					color: "#FFFFFF",
					fontSize: "11px",
					fontWeight: "bold",
					className: "con-vs-chip mt-base p-1 vs-chip-primary con-color",
				},
				infoWindow: {
					content:
						this.routeType.value === "PROGRAMED" || this.routeType.value === "BOTH"
							? generateInfowindowContentSchedule(infoWindowData)
							: `<h5>Posición</h5>`,
				},
				infoLatLng: {lat, lng},
				changeIcon: false,
			};
			let newMarker = addMarkerHereMap(lat, lng, options, false);
			addInfoBubble(newMarker, options.infoWindow.content);
			this.possitionArray.push({lat, lng});
			this.markerArray.push(newMarker);

			//add sequence
			addDomMarker({lat, lng}, infoWindowData.index ? infoWindowData.index : " ");
		},
		//End Tab Route
		//Init Tab Visit Points
		drawVisitPoints() {
			this.moduleResource;
			const data = this.$store.state.moduleVisitPoint.selectedVisitPoints;
			if (data !== null && data.length > 0) {
				this.markerArray = [];
				clearMap();
				data.forEach((element) => {
					this.addMarkerVisitPoint(element.cy, element.cx, element);
				});
				setTimeout(() => {
					this.toggleMapSidebar(false);
					fitBoundsMarkerGroup(this.markerArray);
				}, 700);
			} else {
				this.$vs.notify({
					color: "warning",
					title: this.$t("VisitPointObject.List.SelectVisitPoint.Title"),
					text: this.$t("VisitPointObject.List.SelectVisitPoint.Text"),
				});
			}
		},
		addMarkerVisitPoint(lat, lng, visitPoint) {
			// Opciones
			let options = {
				drag: false,
				icon: visitPointImg,
				title: "Current position",
				label: {
					text: "A",
					color: "#fff",
					fontSize: "11.0px",
				},
				infoWindow: {
					content: generateInfowindowContentVisitPoints(visitPoint),
				},
			};
			let newMarker = addMarkerHereMap(lat, lng, options, false);
			addInfoBubble(newMarker, options.infoWindow.content);
			this.markerArray.push(newMarker);
		},
		//End tab Visit Points
		//Init tab Schedule
		getEvents(startDate, endDate, routeExecute = false) {
			Commons.openLoadingButton.call(this, `btn-excute-route`);
			const payload = {
				init_date: startDate,
				end_date: endDate,
				resource_id:
					this.routeType.value === "EXECUTED" ? this.select1.map(({value}) => value) : [this.select1.value],
				group_by: false,
			};
			this.$store
				.dispatch("moduleSchedule/fetchEventsByResourceId", payload)
				.then((res) => {
					Commons.closeLoadingButton.call(this, `btn-excute-route`);
					if (routeExecute) {
						this.drawEventRouteExecute(res.data.records);
					} else {
						this.drawEventMarkers(res.data.records);
					}
				})
				.catch((err) => {
					Commons.closeLoadingButton.call(this, `btn-excute-route`);
					console.error(err);
				});
		},
		getResourceEvents() {
			const startDate = DateUtils.toDefaultDateTime(this.startDate, "YYYY-MM-DD");
			const endDate = DateUtils.toDefaultDateTime(this.endDate, "YYYY-MM-DD");
			this.getEvents(startDate, endDate);
		},
		drawEventMarkers(data = []) {
			if (data !== null && data.length > 0) {
				this.markerArray = [];
				data.forEach((element) => {
					this.addMarkerEvents(element.cy, element.cx, element);
				});
				fitBoundsMarkerGroup(this.markerArray);
				setTimeout(() => {
					this.toggleMapSidebar(false);
				}, 700);
			} else {
				this.$vs.notify({
					color: "warning",
					title: this.$t("ErrorTitle"),
					text: this.$t("general.NoDataFound"),
				});
			}
		},
		drawEventRouteExecute(data = []) {
			if (data !== null && data.length > 0) {
				this.markerArray = [];
				data.forEach((element) => {
					this.addMarkerRouteExecute(element.cy, element.cx, element);
				});
				//fitBoundsMarkerGroup(this.markerArray);
				setTimeout(() => {
					this.toggleMapSidebar(false);
				}, 700);
			} else {
				this.$vs.notify({
					color: "warning",
					title: this.$t("ErrorTitle"),
					text: this.$t("general.NoDataFound"),
				});
			}
		},
		addMarkerRouteExecute(lat, lng, infoWindowData) {
			let options = {
				drag: false,
				icon: MapMethods.generateMarkerIconEvent(infoWindowData.event_status_id),
				title: "Current position",
				label: {
					text: "A",
					color: "#fff",
					fontSize: "11.0px",
				},
				infoWindow: {
					content: generateInfowindowContentSchedule(infoWindowData),
				},
			};
			let newMarker = addMarkerHereMap(lat, lng, options, true);
			addInfoBubble(newMarker, options.infoWindow.content);
			this.possitionArray.push({lat, lng});
			this.markerArray.push(newMarker);
		},
		addMarkerEvents(lat, lng, infoWindowData) {
			let options = {
				drag: false,
				icon: MapMethods.generateMarkerIconEvent(infoWindowData.event_status_id),
				title: "Current position",
				label: {
					text: "A",
					color: "#fff",
					fontSize: "11.0px",
				},
				infoWindow: {
					content: generateInfowindowContentSchedule(infoWindowData),
				},
			};
			let newMarker = addMarkerHereMap(lat, lng, options, false);
			addInfoBubble(newMarker, options.infoWindow.content);
			this.possitionArray.push({lat, lng});
			this.markerArray.push(newMarker);
		},
		//End tab Schedule
		toggleMapSidebar(val = false) {
			this.$store.dispatch("moduleMap/changeToggleMapSidebar", val);
		},
		getResources(userId = [0]) {
			this.loadedingResource = true;
			const dataPage = {
				page: this.currentPage,
				quantity: this.quantityElementPage,
				ids: userId,
			};
			this.$store
				.dispatch("moduleResource/fetchResourceFilter", dataPage, {
					component: "mapSidebar",
				})
				.then((res) => {
					if (this.tabActive === 0) {
						this.resourcesDataLocal = res.data.records;
					} else {
						this.resourcesDataLocalSelect = res.data.records;
					}
					Object.assign(this.pagination, res.data.pagination);
					//Commons.closeLoadingDiv.call(this, `content-resource-select`);
					this.loadedingResource = false;
					this.loadedingResult = "SUCCESS";
					if (this.tabActive === 0) {
						this.handleChangeGroupTrigger(this.selectedGroup);
						this.confirmKeepGroup();
					}
				})
				.catch((err) => {
					this.loadedingResource = false;
					this.loadedingResult = "ERROR";
					//Commons.closeLoadingDiv.call(this, `content-resource-select`);
					console.error(err);
				});
		},
		changeGroupEmit(group) {
			this.selectedGroup = new Group(group);
			if (this.selectedGroup.resource_id.length > 0) {
				clearMap();
				this.getResources(this.selectedGroup.resource_id);
			} else {
				this.loadedingResult = "EMPTY";
				this.resourcesDataLocal = [];
				this.resourcesDataLocalSelect = [];
			}
		},
		confirmKeepGroup() {
			if (this.$store.state.askAgainFavoriteGroup) this.activeConfirmKeepGroupPrompt = true;
		},
		acceptAlert() {
			this.updateGroupOnPreferences();
		},
		close() {},
		clearValMultiple() {
			this.valMultipe.value1 = "";
			this.valMultipe.value2 = "";
		},
		async updateGroupOnPreferences() {
			if (this.selectedGroup.id) {
				try {
					await this.$store.dispatch("modulePreferences/updatePreferences", {
						default_group_tracking: this.selectedGroup,
						show_default_group_tracking: true,
					});
				} catch (error) {}
			}
		},
		setRandonColor() {
			if (this.colorMap.size <= 0) {
				this.select1.forEach((r) => {
					if (!this.colorMap.has(r.value)) {
						const data = {resourceId: r.value, color: this.genterateRandonColor()};
						this.$store.commit("moduleMap/SET_MAP_COLOR", data);
					}
				});
			}
		},
		genterateRandonColor() {
			let r = () => (Math.random() * 256) >> 0;
			return `rgb(${r()}, ${r()}, ${r()})`;
		},
	},
};
</script>

<style lang="scss" scoped>
@import "../../../src/assets/scss/vuexy/pages/search.scss";

.add-new-data-sidebar {
	::v-deep .vs-sidebar--background {
		z-index: 51010;
	}

	::v-deep .vs-sidebar {
		z-index: 51010;
		width: 450px;
		max-width: 90vw;

		.img-upload {
			margin-top: 2rem;

			.con-img-upload {
				padding: 0;
			}

			.con-input-upload {
				width: 100%;
				margin: 0;
			}
		}
	}
}

.scroll-area {
	margin: auto;
	width: auto;
	height: calc(var(--vh, 1vh) * 65 - 4.3rem);
}

.scroll-area--data-list-add-new {
	height: calc(var(--vh, 1vh) * 100 - 8.3rem);
	//height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

	&:not(.ps) {
		overflow-y: auto;
	}
}

.custom-class {
	color: #00ff00;
}

.cursor-pointer {
	cursor: pointer;
}

.cursor-pointer {
	cursor: pointer;
}

.margin-less {
	margin-right: -15px;
}

.btn-maximize {
	float: right;
}

.max-heigth {
	height: 100vh;

	div {
		height: 100%;
	}
}
</style>
